export default __webpack_public_path__ + "static/logo-2c13207fd92730c963b497b059ea10d5.png";